module.exports = __webpack_public_path__ + "static/media/er.9ac1b3f4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/er.svg
// module id = 2084
// module chunks = 0